import { useAppSelector } from "@/reducers/hooks"
import { isInitSyncDone } from "@/reducers/roomSyncStatusSelectors"
import { Spinner } from "@/components/ui/spinner"

export default function RoomLoading() {
  const hasInitSyncCompleted = useAppSelector(isInitSyncDone)

  if (hasInitSyncCompleted) {
    return null
  }

  return (
    <div className="absolute left-32 top-1/2 ml-1 -translate-x-1/2 -translate-y-1/2">
      <Spinner size="xs" />
    </div>
  )
}
